import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import es from './locales/es.json';

/**
 * CLAUDE.md: no hardcoded user-facing copy. Every string goes through a key.
 * `es` is the placeholder second locale — see SPEC.md §9.4, the real second
 * language is still an open question.
 */
export const SUPPORTED_LOCALES = ['en', 'es'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export function initI18n(defaultLocale: string = 'en'): typeof i18n {
  void i18n.use(initReactI18next).init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: defaultLocale,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }, // React already escapes
  });

  return i18n;
}

export default i18n;
